const Routes = [];

/*** PUBLIC RULES */
Routes.push({
    path: "/m-deploy",
    meta: {},
    name: "m-deploy",
    component: () => import("@/modules/mdeploy/RootView")
});

export default Routes;